<template>
  <v-card flat class="futuristic-card">
    <v-card-title class="card-header">
      <h4 class="earth-color">BOOKINGS REPORTS</h4>
      <div class="title-decoration"></div>
    </v-card-title>
    
    <v-tabs slider-color="#587e27" class="futuristic-tabs">
      <v-tab ripple key="dailyreport">Daily Report</v-tab>
      <v-tab ripple key="allBookingsReport">All Bookings Report</v-tab>
      <v-tab ripple key="gateentrydaily">Bookings Daily Gate Entry</v-tab>
      <v-tab ripple key="allBookingInspectionReport">Bookings Inspection Report</v-tab>
      <v-tab ripple key="volume">Bookings Volume</v-tab>
      <v-tab ripple key="members">Members</v-tab>
      <v-tab ripple key="volunteers">ICE Programmes</v-tab>
      <v-tab ripple key="donations">Donations</v-tab>
      <v-tab ripple key="partners">Partners</v-tab>
      <v-tab ripple key="inventory">Activities/Items</v-tab>
      <v-tab ripple key="accommodation">Accommodation</v-tab>
      <v-tab ripple key="users">Users</v-tab>

      <v-tab-item key="dailyreport">
        <v-card flat class="futuristic-inner-card">
          <v-form @submit.prevent>
            <v-layout row wrap>
              <v-flex lg4 md3 sm12 xs12>
                <v-container>
                  <v-dialog
                    ref="dialog"
                    persistent
                    v-model="modal1"
                    lazy
                    full-width
                    width="290px"
                    :return-value.sync="report.start_date"
                  >
                    <v-text-field
                      slot="activator"
                      label="Start Date"
                      v-model="report.start_date"
                      readonly
                      class="futuristic-input"
                    ></v-text-field>
                    <v-date-picker v-model="report.start_date" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn
                        :depressed="true"
                        flat
                        color="#587e27"
                        @click="modal1 = false"
                        class="futuristic-btn"
                        >Cancel</v-btn
                      >
                      <v-btn
                        :depressed="true"
                        flat
                        color="#587e27"
                        @click="$refs.dialog.save(report.start_date)"
                        class="futuristic-btn"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </v-container>
              </v-flex>

              <v-flex mlg4 md3 sm12 xs12>
                <v-container>
                  <v-dialog
                    ref="dialog1"
                    persistent
                    v-model="modal2"
                    lazy
                    full-width
                    width="290px"
                    :return-value.sync="report.end_date"
                  >
                    <v-text-field
                      slot="activator"
                      label="End Date"
                      v-model="report.end_date"
                      readonly
                      class="futuristic-input"
                    ></v-text-field>
                    <v-date-picker v-model="report.end_date" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn
                        :depressed="true"
                        flat
                        color="#587e27"
                        @click="modal2 = false"
                        class="futuristic-btn"
                        >Cancel</v-btn
                      >
                      <v-btn
                        :depressed="true"
                        flat
                        color="#587e27"
                        @click="$refs.dialog1.save(report.end_date)"
                        class="futuristic-btn"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </v-container>
              </v-flex>
              
              <v-flex lg4 md3 sm12 xs12>
                <v-container>
                  <v-select
                    label="Select Booking Type"
                    v-model="report.booking_type"
                    :items="allReportBookingTypes"
                    :rules="[(v) => !!v || 'Booking Type is required']"
                    required
                    item-text="value"
                    item-value="id"
                    :loading="$loadingTrue"
                    class="futuristic-input"
                  ></v-select>
                </v-container>
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout row wrap>
            <v-flex lg12 md12 sm12 xs12>
              <v-container>
                <v-btn
                  :depressed="true"
                  color="#587e27"
                  type="submit"
                  :loading="this.$store.state.LoadingStore.loading"
                  @click="requestDailyReport"
                  class="futuristic-btn"
                  >Generate Bookings Report</v-btn
                >
                <v-btn
                  color="#587e27"
                  @click="DownloadDailyCSV()"
                  :loading="this.$store.state.LoadingStore.loading"
                  class="futuristic-btn secondary"
                  >Download Bookings Report<v-icon color="#587e27"
                    >save_alt</v-icon
                  ></v-btn
                >
              </v-container>
            </v-flex>
            <hr class="divider" />
            <v-flex lg12 md12 sm12 xs12>
              <v-container>
                <v-btn
                  :depressed="true"
                  color="#ff9800"
                  type="submit"
                  :loading="this.$store.state.LoadingStore.loading"
                  @click="requestVisitorsReport"
                  class="futuristic-btn"
                  >Generate Visitors Report</v-btn
                >
                <v-btn
                  color="#587e27"
                  @click="DownloadVisitorsReport()"
                  :loading="this.$store.state.LoadingStore.loading"
                  class="futuristic-btn secondary"
                  >Download Visitors Report<v-icon color="#ff9800"
                    >save_alt</v-icon
                  ></v-btn
                >
              </v-container>
            </v-flex>
          </v-layout>
        </v-card>
      </v-tab-item>
      
      <v-tab-item key="allbookingsReport">
        <all-bookings-report class="futuristic-inner-card"></all-bookings-report>
      </v-tab-item>
     
      <v-tab-item key="gateentrydaily">
        <v-card flat class="futuristic-inner-card">
          <v-data-table
            :headers="columns"
            :items="dailyReportData"
            :search="search"
            :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
            :disable-initial-sort="false"
            :loading="$loadingTrue"
            :expand="expand"
            class="futuristic-table"
          >
            <v-progress-linear
              slot="progress"
              color="#587e27"
              indeterminate
            ></v-progress-linear>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.Conservancy_Fee_Category }}</td>
              <td>{{ props.item.Destination }}</td>
              <td>{{ props.item.No_of_Guests }}</td>
              <td>{{ props.item.No_of_Nights }}</td>
              <td>{{ props.item.Currency }}</td>
              <td>{{ props.item.Total_Cost }}</td>
            </template>
            <template slot="footer" class="pull-right">
              <v-btn color="#f5f7fa" @click="DownloadCSV()" class="futuristic-btn secondary"
                >Download Report
                <v-icon color="#587e27">save_alt</v-icon></v-btn
              >
            </template>
          </v-data-table>
        </v-card>
      </v-tab-item>

      <v-tab-item key="allBookingInspectionReport">
        <v-card flat class="futuristic-inner-card">
          <v-form @submit.prevent>
            <v-layout row wrap>
              <v-flex lg4 md3 sm12 xs12>
                <v-container>
                  <v-dialog
                    ref="dialog11"
                    persistent
                    v-model="inspection_start_date_modal"
                    lazy
                    full-width
                    width="290px"
                    :return-value.sync="inspection_report.start_date"
                  >
                    <v-text-field
                      slot="activator"
                      label="Start Date"
                      v-model="inspection_report.start_date"
                      readonly
                      class="futuristic-input"
                    ></v-text-field>
                    <v-date-picker v-model="inspection_report.start_date" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn
                        :depressed="true"
                        flat
                        color="#587e27"
                        @click="inspection_start_date_modal = false"
                        class="futuristic-btn"
                        >Cancel</v-btn
                      >
                      <v-btn
                        :depressed="true"
                        flat
                        color="#587e27"
                        @click="$refs.dialog11.save(inspection_report.start_date)"
                        class="futuristic-btn"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </v-container>
              </v-flex>
              <v-flex mlg4 md3 sm12 xs12>
                <v-container>
                  <v-dialog
                    ref="dialog12"
                    persistent
                    v-model="inspection_end_date_modal"
                    lazy
                    full-width
                    width="290px"
                    :return-value.sync="inspection_report.end_date"
                  >
                    <v-text-field
                      slot="activator"
                      label="End Date"
                      v-model="inspection_report.end_date"
                      readonly
                      class="futuristic-input"
                    ></v-text-field>
                    <v-date-picker v-model="inspection_report.end_date" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn
                        :depressed="true"
                        flat
                        color="#587e27"
                        @click="inspection_end_date_modal = false"
                        class="futuristic-btn"
                        >Cancel</v-btn
                      >
                      <v-btn
                        :depressed="true"
                        flat
                        color="#587e27"
                        @click="$refs.dialog12.save(inspection_report.end_date)"
                        class="futuristic-btn"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </v-container>
              </v-flex>
              <v-flex lg4 md3 sm12 xs12>
                <v-container>
                  <v-select
                    label="Is Alert"
                    v-model="inspection_report.is_alert"
                    :items="isAlert"
                    item-text="value"
                    item-value="id"
                    :loading="$loadingTrue"
                    class="futuristic-input"
                  ></v-select>
                </v-container>
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout row wrap>
            <v-flex lg12 md12 sm12 xs12>
              <v-container>
                <v-btn
                  :depressed="true"
                  color="#587e27"
                  type="submit"
                  :loading="this.$store.state.LoadingStore.loading"
                  @click="requestBookingsInspectionReport"
                  class="futuristic-btn"
                  >Generate Bookings Inspection Report</v-btn
                >
                <v-btn
                  color="#f5f7fa"
                  @click="DownloadBookingsInspectionCSV()"
                  :loading="this.$store.state.LoadingStore.loading"
                  class="futuristic-btn secondary"
                  >Download Bookings Inspection Report<v-icon color="#587e27"
                    >save_alt</v-icon
                  ></v-btn
                >
              </v-container>
            </v-flex>
          </v-layout>
        </v-card>
      </v-tab-item>

      <v-tab-item key="volume">
        <v-card flat class="futuristic-inner-card">
          <v-toolbar flat color="white" class="futuristic-toolbar">
            <h4 class="earth-color">Current Month: {{ this.this_month }}</h4>
          </v-toolbar>
          <v-data-table
            :headers="volume_columns"
            :items="$bookingsVolume"
            :search="search"
            :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
            :disable-initial-sort="false"
            :loading="$loadingTrue"
            :expand="expand"
            class="futuristic-table"
          >
            <v-progress-linear
              slot="progress"
              color="#587e27"
              indeterminate
            ></v-progress-linear>
            <template slot="items" slot-scope="props">
              <td>{{ props.item.date }}</td>
              <td>{{ props.item.bookings_count }}</td>
              <td>{{ props.item.guests }}</td>
              <td>{{ props.item.currency }}</td>
              <td>
                {{
                  props.item.booking_total
                    .toLocaleString("en")
                    .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
                }}
              </td>
            </template>
          </v-data-table>
          <div class="text-xs-center" v-if="$bookingsVolume.length <= 0">
            <ball-clip-rotate-pulse-loader
              color="#587e27"
              size="50px"
            ></ball-clip-rotate-pulse-loader>
          </div>
          <div class="text-xs-center">
            <h4
              style="padding-bottom: 20px"
              v-if="$bookingsVolumeGtt !== null"
              class="earth-color"
            >
              KES
              {{
                $bookingsVolumeGtt
                  .toLocaleString("en")
                  .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
              }}
            </h4>
          </div>
        </v-card>
      </v-tab-item>
      
      <v-tab-item key="members">
        <members class="futuristic-inner-card"></members>
      </v-tab-item>
      
      <v-tab-item key="volunteers">
        <volunteers class="futuristic-inner-card"></volunteers>
      </v-tab-item>
      
      <v-tab-item key="donations">
        <donations class="futuristic-inner-card"></donations>
      </v-tab-item>
      
      <v-tab-item key="partners">
        <partners class="futuristic-inner-card"></partners>
      </v-tab-item>
      
      <v-tab-item key="inventory">
        <activities class="futuristic-inner-card"></activities>
      </v-tab-item>
      
      <v-tab-item key="accommodation">
        <accommodation class="futuristic-inner-card"></accommodation>
      </v-tab-item>
      
      <v-tab-item key="users">
        <users class="futuristic-inner-card"></users>
      </v-tab-item>
    </v-tabs>
  </v-card>
</template>

<script>
import Members from "../Membership/Members";
import Volunteers from "../VolunteerProgram/VolunteerPrograms";
import Partners from "../Partners/Partners";
import Donations from "../Donations/Donations";
import Activities from "../Inventory/Inventory";
import Accommodation from "../Facilities/Facilities";
import Users from "../Users/Users";
import AllBookingsReport from "./AllBookingsReport.vue";

export default {
  components: {
    Members,
    Volunteers,
    Partners,
    Donations,
    Accommodation,
    Activities,
    Users,
    AllBookingsReport
  },
  data() {
    return {
      expand: false,
      menu1: false,
      modal1: false,
      menu2: false,
      modal2: false,
      inspection_start_date_modal: false,
      inspection_end_date_modal: false,
      this_month: this.$moment().month("Mar"),
      title: "Daily Entry Report",
      search: "",
      report: {
        start_date: this.$moment().format("YYYY-MM-DD"),
        end_date: this.$moment().format("YYYY-MM-DD"),
        booking_type: "",
        csv: "",
      },
      inspection_report: {
        start_date: this.$moment().format("YYYY-MM-DD"),
        end_date: this.$moment().format("YYYY-MM-DD"),
        is_alert: "",
        csv: "",
      },
      columns: [
        {
          text: "Category",
          value: "Conservancy_Fee_Category",
        },
        {
          text: "Destination",
          value: "Destination",
        },
        {
          text: "Pax",
          value: "No_of_Guests",
        },
        {
          text: "Nights",
          value: "No_of_Nights",
        },
        {
          text: "Currency",
          value: "Currency",
        },
        {
          text: "Cost",
          value: "Total_Cost",
        },
      ],
      volume_columns: [
        {
          text: "Date",
          value: "date",
        },
        {
          text: "Bookings",
          value: "bookings_count",
        },
        {
          text: "Pax",
          value: "guests",
        },
        {
          text: "Currency",
          value: "currency",
        },
        {
          text: "Amount",
          value: "booking_total",
        },
      ],
    };
  },
  beforeCreate() {
    // var data = {
    //   session_id: localStorage.getItem("lkjhgfdsa"),
    // };
    // var data2 = {
    //   start_date: this.$moment().startOf("month").format("YYYY-MM-DD"),
    //   end_date: this.$moment().endOf("month").format("YYYY-MM-DD"),
    //   session_id: localStorage.getItem("lkjhgfdsa"),
    // };
    // var data3 = {
    //   start_date: this.$moment().format("YYYY-MM-DD"),
    //   end_date: this.$moment().format("YYYY-MM-DD"),
    //   session_id: localStorage.getItem("lkjhgfdsa"),
    // };
    // this.$store.dispatch("fetch_daily_reports", data);
    // this.$store.dispatch("fetch_gate_entry_reports", data);
    // this.$store.dispatch("fetch_booking_volume_reports", data2);
    // this.$store.dispatch("fetch_visitors_report", data3);
  },
  methods: {
    requestDailyReport: function () {
      var data = {
        start_date: this.report.start_date,
        end_date: this.report.end_date,
        booking_type: this.report.booking_type,
        session_id: localStorage.getItem("lkjhgfdsa"),
      }
      this.$store.dispatch("fetch_daily_reports", data);
    },
    requestBookingsInspectionReport: function () {
      var data = {
        start_date: this.inspection_report.start_date,
        end_date: this.inspection_report.end_date,
        is_alert: this.inspection_report.is_alert,
        session_id: localStorage.getItem("lkjhgfdsa"),
      }
      this.$store.dispatch("fetch_bookings_inspection_reports", data);
    },
    requestReport: function () {
      this.$store.dispatch("generate_booking_reports", this.report);
    },
    requestVisitorsReport: function () {
      var data = {
        start_date: this.report.start_date,
        end_date: this.report.end_date,
        session_id: localStorage.getItem("lkjhgfdsa"),
      };
     
      this.$store.dispatch("fetch_visitors_report", data);
    },
    DownloadCSV() {
      window.open(this.csvdailyReportData.url, "_blank");
    },
    DownloadDailyCSV() {
      window.open(this.dailyCSVReportData.url, "_blank");
    },
    DownloadVisitorsReport() {
      window.open(this.visitorsReportData.url, "_blank");
    },
    DownloadBookingsInspectionCSV() {
      window.open(this.bookingsInspectionReportData.url, "_blank");
    },
  },
  computed: {
    allReportBookingTypes: function () {
      let bookingTypes = [
        {
          id: "1",
          value: "Paid Bookings",
        },
        {
          id: "2",
          value: "FOC Bookings",
        },
        {
          id: "3",
          value: "Cancelled Bookings",
        },
      ];
      return bookingTypes
    },
    isAlert: function () {
      let alert = [
        {
          id: "1",
          value: "True",
        },
        {
          id: "2",
          value: "False",
        },
      ];
      return alert
    },
  },
};
</script>

<style scoped>
/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-inner-card {
  padding: 16px;
  border-radius: 8px;
  background: #f8f9fa;
  margin: 8px;
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px 8px 0 0;
  display: flex;
  flex-direction: column;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 1.5rem;
}

.earth-color.h6 {
  font-size: 1.2rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-top: 8px;
  width: 100px;
}

.futuristic-tabs {
  background: transparent;
}

.futuristic-tabs >>> .v-tabs__bar {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
}

.futuristic-tabs >>> .v-tab {
  color: #587e27;
  font-weight: 500;
}

.futuristic-tabs >>> .v-tab--active {
  color: #587e27;
  font-weight: 600;
}

.futuristic-input >>> .v-input__control,
.futuristic-input >>> .v-text-field__slot,
.futuristic-input >>> .v-select__slot {
  background: #ffffff;
  border-radius: 6px;
  padding: 0 8px;
}

.futuristic-input >>> .v-label {
  color: #587e27;
  font-weight: 500;
}

.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
  margin: 4px;
  color: white;
}

.futuristic-btn.secondary {
  background: #f5f7fa;
  color: #587e27;
  border: 1px solid #e0e0e0;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.futuristic-table {
  width: 100%;
  border-collapse: collapse;
  background: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.futuristic-table >>> th,
.futuristic-table >>> td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.futuristic-table >>> th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  color: #587e27;
  font-weight: 600;
}

.futuristic-table >>> tr:hover {
  background: #f5f7fa;
}

.futuristic-toolbar {
  border-radius: 8px;
  margin-bottom: 16px;
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
}

.divider {
  border: 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, #587e27, transparent);
  width: 100%;
  margin: 16px 0;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .futuristic-card {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.25rem;
  }

  .earth-color.h6 {
    font-size: 1rem;
  }

  .futuristic-inner-card {
    padding: 12px;
    margin: 6px;
  }

  .futuristic-table >>> th,
  .futuristic-table >>> td {
    padding: 8px;
  }
}

@media (max-width: 600px) {
  .futuristic-card {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.1rem;
  }

  .earth-color.h6 {
    font-size: 0.9rem;
  }

  .futuristic-inner-card {
    padding: 8px;
    margin: 4px;
  }

  .futuristic-table >>> th,
  .futuristic-table >>> td {
    padding: 6px;
    font-size: 0.85rem;
  }
  
  .futuristic-btn {
    font-size: 0.8rem;
    padding: 0 12px;
    height: 36px;
  }
}
</style> 